module.exports = __webpack_public_path__ + "static/media/sjeldan.3d6ad1c7.m4a";